var _rect, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_3563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1323 48.5244C41.1422 48.5244 49.2569 40.4098 49.2569 30.3999C49.2569 20.39 41.1422 12.2754 31.1323 12.2754C21.1224 12.2754 13.0078 20.39 13.0078 30.3999C13.0078 40.4098 21.1224 48.5244 31.1323 48.5244Z",
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_3563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1005 48.5038C41.1166 48.5038 49.2363 40.3843 49.2363 30.3682C49.2363 20.3521 41.1166 12.2324 31.1005 12.2324C21.0845 12.2324 12.9648 20.3521 12.9648 30.3682C12.9648 40.3843 21.0845 48.5038 31.1005 48.5038Z",
    fill: "#5FC1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4503 64.1273C36.0963 64.1273 46.3479 53.8757 46.3479 41.2296C46.3479 28.5836 36.0963 18.332 23.4503 18.332C10.8043 18.332 0.552734 28.5836 0.552734 41.2296C0.552734 53.8757 10.8043 64.1273 23.4503 64.1273Z",
    fill: "#2AB2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4963 59.9751C30.6825 59.9751 38.1295 52.5283 38.1295 43.3421C38.1295 34.1558 30.6825 26.709 21.4963 26.709C12.3102 26.709 4.86328 34.1558 4.86328 43.3421C4.86328 52.5283 12.3102 59.9751 21.4963 59.9751Z",
    fill: "#0088E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5016 57.7589C25.7157 57.7589 30.7531 52.7214 30.7531 46.5073C30.7531 40.2934 25.7157 35.2559 19.5016 35.2559C13.2875 35.2559 8.25 40.2934 8.25 46.5073C8.25 52.7214 13.2875 57.7589 19.5016 57.7589Z",
    fill: "#1976D2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0853 12.8424C41.8542 11.5761 42.5942 10.3518 43.4143 9C44.3302 9.66543 45.211 10.2485 46.0295 10.9107C57.481 20.1734 58.0532 37.8703 47.2586 47.8953C43.8651 51.0464 39.9248 53.0766 35.4219 54.0069C34.8753 54.1201 34.7345 54.3284 34.7505 54.8452C34.7826 55.8562 34.7601 56.8689 34.7601 57.9931C33.5901 57.9931 32.5079 57.9931 31.4257 57.9931C30.3883 57.9931 29.3493 57.9753 28.3118 57.9995C27.8291 58.0109 27.6469 57.8364 27.6628 57.3471C27.69 56.5427 27.6469 55.7367 27.6757 54.9341C27.6933 54.4302 27.5142 54.2685 27.0058 54.1863C21.7549 53.3399 17.22 51.0529 13.4604 47.2396C13.3293 47.1072 13.1998 46.9715 13.0767 46.8309C13.0464 46.7954 13.0432 46.7357 13 46.6064C14.0182 45.6471 15.062 44.6634 16.1426 43.646C20.8134 48.4009 26.4433 50.5909 33.0401 49.8254C38.6157 49.1777 43.1506 46.5031 46.557 41.9953C53.3169 33.0491 51.5138 19.5532 41.0837 12.8456L41.0853 12.8424Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon5);
export default __webpack_public_path__ + "static/media/IntegrationsIcon5.15c3791b88b95ea70a7879aeb0b059a5.svg";
export { ForwardRef as ReactComponent };